import { DischargePageTranslations } from "./types";

export const deTranslations: DischargePageTranslations = {
    dischargedPatients: "Übersicht",
    table: {
        feedback: "Feedback",
        noPatient: "Noch keine Patient:innen entlassen",
        columns: {
            location: "Aufenthaltsort",
            name: "Name",
            ageGender: "Alter/Geschlecht",
            symptom: "Symptom",
            diagnosis: "Ihre Diagnose",
            realDiagnosis: "Korrekte Diagnose",
            score: "Erreichte Punkte [%]",
        },
    },
    feedback: {
        age: "Alter",
        sex: "Geschlecht",
        yourDiagnosis: "Ihre Diagnose",
        correctDiagnosis: "Korrekte Diagnose",
        score: "Erreichte Punkte [%]",
        yourManagement: "Indizierte diagnostische und therapeutische Maßnahmen",
        feedback: "Feedback",
    }
};
